import React from 'react';
import classnames from 'classnames';

import type { Bygg } from '@klp/bygg/classes';

import './ByggEnergyScore.scss';

interface IProps {
    energiKarakter: Bygg['energiKarakter'];
    andelFossilEl: Bygg['andelFossilEl'];
}
export type IByggEnergyScoreProps = IProps;

export const ByggEnergyScore: React.FC<IProps> = ({
    energiKarakter,
    andelFossilEl,
}) => {
    const calculateEnergyMark = (fossilElValue: number): number => {
        switch (true) {
            case fossilElValue <= 30:
                return 1;
            case fossilElValue <= 47.5:
                return 2;
            case fossilElValue <= 65:
                return 3;
            case fossilElValue <= 82.5:
                return 4;
            default:
                return 5;
        }
    };

    const energyMark = calculateEnergyMark(andelFossilEl);

    const className = classnames(
        'ByggEnergyScore',
        `ByggEnergyScore--${energyMark}`,
    );

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 93 77.987"
            className={className}
        >
            <g transform="translate(-71.835 -798.77)">
                <g transform="translate(-358.67 457.9)">
                    <path
                        className="ByggEnergyScore__Fill"
                        d="m477 342.37-45 29.995h15v44.992h60v-44.992h15l-45-29.995z"
                    />
                </g>
            </g>
            <text
                x="46.22197px"
                textRendering="geometricPrecision"
                y="65px"
                textAnchor="middle"
                className="ByggEnergyScore__Text"
            >
                {energiKarakter}
            </text>
        </svg>
    );
};
